import { IconButton, Dropdown } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { StyledAddWebsitesDropdownItem, StyledOptionDescription } from "./styles";

export type AddWebsitesDropdownProps = {
    onOpenWebsitesModal(): void;
    onOpenRecommendations(): void;
    isDisabled: boolean;
};

const AddWebsitesDropdown = (props: AddWebsitesDropdownProps) => {
    const { onOpenWebsitesModal, onOpenRecommendations, isDisabled } = props;

    const onClick = ({ id }: { id: string }) => {
        if (id === "open-websites-modal") {
            onOpenWebsitesModal();
        }

        if (id === "open-recommendations") {
            onOpenRecommendations();
        }
    };

    return (
        <div>
            <Dropdown
                disabled={isDisabled}
                width={240}
                onClick={onClick}
                dropdownPopupPlacement="bottom-right"
            >
                <IconButton
                    isDisabled={isDisabled}
                    key="add-websites-dropdown-button"
                    type="outlined"
                    iconName="add"
                >
                    {translate("si.pages.my_lists.button.more_leads")}
                </IconButton>
                <StyledAddWebsitesDropdownItem
                    iconName="add"
                    iconSize={"sm"}
                    id="open-websites-modal"
                    className="more_leads__item"
                    key="add-websites-dropdown-open-modal-button"
                >
                    <div>{translate("workspace.sales.add.addNew")}</div>
                    <StyledOptionDescription>{translate("workspace.sales.add.description")}</StyledOptionDescription>
                </StyledAddWebsitesDropdownItem>
                <StyledAddWebsitesDropdownItem
                    iconName="wand"
                    iconSize={"sm"}
                    id="open-recommendations"
                    className="more_leads__item"
                    key="add-websites-dropdown-open-recommendations-button"
                >
                    <div>{translate("workspace.recommendation_sidebar.indicator")}</div>
                    <StyledOptionDescription>
                        {translate("workspace.recommendation_sidebar.indicatorDescription")}
                    </StyledOptionDescription>
                </StyledAddWebsitesDropdownItem>
            </Dropdown>
        </div>
    );
};

export default AddWebsitesDropdown;
